module.exports = __webpack_public_path__ + "img/609ab93b9df2041f0a4e2c34e2806df3.89d97511.png";